import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  rootRow: {
    borderBottom: `1px solid ${theme.palette.darkGrey[5]}`,
    width: '100%',
  },
  headerRow: {
    padding: '1.5rem 2rem',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  labelRow: {
    textAlign: 'start',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.spacing(2),
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
  wrapperTimesRow: {
    '& > :not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
    '& > div': {
      fontSize: theme.typography.pxToRem(14),
    },
  },

  chipTimesRow: {
    backgroundColor: theme.palette.darkGrey[5],
    fontSize: theme.typography.pxToRem(14),
    marginRight: theme.spacing(2),
    minWidth: theme.spacing(5),

    '& > span': {
      paddingRight: theme.typography.pxToRem(4),
      paddingLeft: theme.typography.pxToRem(4),
    },
  },
  contentLeftRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    '& > :first-child': {
      marginRight: theme.spacing(3),
    },
  },
  contentRightRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    '& > :first-child': {
      marginRight: theme.spacing(5),
    },
  },
  providersRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    visibility: 'visible',
    '& > :not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  table: {
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
  },
  row: {
    display: 'flex',
    whiteSpace: 'nowrap',
    color: 'inherit',
    outline: 0,
    verticalAlign: 'middle',
    width: '100%',
  },
  td: {
    width: '100%',
    padding: '0 !important',
  },
}));

export default useStyles;
